import { defineStore } from 'pinia';
import api from '@/services/api';
import { getParamsUrl } from './moneda_utils';

export const useMonedaStore = defineStore('monedaStore', {
  state: () => ({
    monedaList: [],
    page: 1,
  }),
  actions: {
    async findAllMonedaHTTP(params) {
      const result = await api.get(`/moneda?${getParamsUrl({ page: +this.page, ...params })}`);
      if (result && result.data) {
        this.monedaList.splice(0, this.monedaList.length, ...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },

    async firstMoneda() {
      this.setPage(1);
      this.emptyList();
      await this.findAllMonedaHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    async updateMonedasHTTP(toSave) {
      const patches = toSave.map((m) =>
        api.patch(`/moneda/${m.Codigo}`, {
          CotizacionCompra: m.CotizacionCompra ?? 0,
          CotizacionVenta: m.CotizacionVenta ?? 0,
          EsMonedaPrincipal: m.EsMonedaPrincipal ?? false,
        }),
      );
      await Promise.all(patches);
    },
    emptyList() {
      this.monedaList = [];
    },
  },
});
